<template>
  <div class="combobox-rental-dispense-item-info grow">
    <div class="flex flex-row">
      <span class="grow space-x-1">
        <FontAwesomeIcon
          :icon="['fas', 'money-bill-wave']"
          class="text-green-800"
          title="Verhuur"
        />
        <span class="inline-block font-bold!">Verhuur:</span>
        <span>
          {{ rentalDispenseItem.name }}
        </span>
        <span>{{ rentalDispenseItem.getUnitName() }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

defineProps<{
  rentalDispenseItem: RentalDispenseItem
}>()

defineOptions({
  inheritAttrs: false
})
</script>

<style scoped></style>
